import { Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, Subject } from 'rxjs';

export interface AnimationStyleUpdateQuery {
  selector: string;
  styles: { [key: string]: string }[];
}

@Injectable({
  providedIn: 'root',
})
export class MainLogoAnimService {
  private _animHeightUpdateSubject$ = new Subject<number>();
  private _animationStyleUpdateQuery = new Subject<AnimationStyleUpdateQuery>();
  private _animDestroySubject$ = new Subject();
  // ------------------------------------------Getters&Setters|

  public get animHeight$(): Observable<number> {
    return this._animHeightUpdateSubject$.pipe(catchError(() => EMPTY));
  }

  public get animDestroy$() {
    return this._animDestroySubject$.pipe(catchError(() => EMPTY));
  }

  public get animationStyleUpdate$() {
    return this._animationStyleUpdateQuery;
  }

  public animationRefreshSubject$ = new Subject();

  // ------------------------------------------Constructors|

  constructor() {}

  // ------------------------------------------Public methods|

  public updateHeight(height: number) {
    this._animHeightUpdateSubject$.next(height);
  }

  public updateStyleOfBook(
    selector: string,
    styles: { [key: string]: string | number }
  ) {}

  public destroy() {}
}
